export default __webpack_public_path__ + "static/media/mongodblogo.3b54195b.png";